define('models/user/resetpassword/resetpassword',['backbone',
        "models/shared/lookups/systext"
], function (Backbone, SystemText) {
    var ResetPassword = Backbone.Model.extend({
        urlRoot: function () {
            return pf.url + "/ResetPassword/" + this.FPG;
        },
        initialize: function (options) {
            options || (options = {});

           this.FPG = options.FPG;
        },
        parse: function (data) {
            var response = {};
            response.Email = data.E;
            response.Password = data.P;
            response.FPG = data.FPG;
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.FPG = this.FPG;
            data.P = this.attributes.Password;
            data.E = this.attributes.EmailAddress;
  
            this.attributes = data;
            return Backbone.Model.prototype.save.call(this, data, options);
        },
        validation: {
            EmailAddress: {
                required: true,
                msg: sysText['FV']['required']['email'],
            },
            Password: {
                required: true,
                //minLength: 8,

                //msg: sysText['FV']['invalid']['password'],
                fn: function (value, attr, computedState) {
                    if (value == undefined)
                        value = computedState.PD;
                    var pattern = new RegExp(/(?=^.{8,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])/);

                    if (!pattern.test(value)) {
                        return sysText['FV']['invalid']['password'];
                    } else if (value == null || value == "") {
                        return sysText['FV']['invalid']['password'];
                    } else {
                        var cp = computedState.PasswordConfirm;
                        if (value != cp) {
                            return sysText['FV']['invalid']['passwordsDoNotMatch'];
                        }
                    }
                }
            },
            PasswordConfirm: {
                required: true,
                minLength: 8,
                //msg: sysText['FV']['invalid']['password'],
                fn: function (value, attr, computedState) {

                    var pattern = new RegExp(/(?=^.{8,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])/);

                    if (!pattern.test(value)) {
                        return sysText['FV']['invalid']['password'];
                    } else
                        if (value == null || value == "") {
                            return sysText['FV']['invalid']['password'];
                        } else {
                            var cm = computedState.Password;
                            if (value != cm) {
                                return sysText['FV']['invalid']['passwordsDoNotMatch'];
                            }
                        }
                }
            },
            //Password: {
            //    required: true,
            //    minLength: 8,
            //    //msg: sysText['FV']['invalid']['password'],
            //    fn: function (value, attr, computedState) {
            //        if (value == null || value == "") {
            //            return sysText['FV']['invalid']['password'];
            //        }
            //        else
            //            return "";

            //    }
            //},
            //PasswordConfirm: {
            //    required: true,
            //    minLength: 8,
            //    //msg: sysText['FV']['invalid']['password'],
            //    fn: function (value, attr, computedState) {
            //        if (value == null || value == "") {
            //            return sysText['FV']['invalid']['password'];
            //        } else {
            //            var cm = computedState.Password;
            //            if (value != cm) {
            //                return sysText['FV']['invalid']['passwordsDoNotMatch'];
            //            }
            //            else
            //                return "";
            //        }
            //    }
            //},
        }
    });

    return ResetPassword;
});

